var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinumHydrafacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#A0CFDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1173 30.8787C16.1545 32.118 16.6123 33.3499 17.5055 34.3399C18.756 35.7281 20.5648 36.3198 22.2842 36.0816",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9065 24.377C32.1585 22.7394 29.0657 16.2673 23.9818 9.15139C23.5352 8.52986 22.6048 8.52986 22.1619 9.15139C17.0743 16.2673 13.9815 22.7394 13.2334 24.377C12.5003 25.8508 12.0834 27.4921 12.0834 29.2487C12.0834 35.3152 17.0036 40.2241 23.07 40.2241C29.1364 40.2241 34.0565 35.3152 34.0565 29.2487C34.0565 27.4921 33.6397 25.8508 32.9065 24.377Z",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0006,
    cy: 18.5719,
    r: 7.01604,
    fill: "#A0CFDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2491 9.21802C30.2491 13.4285 26.8366 16.8411 22.6261 16.8411C26.8366 16.8411 30.2491 20.2536 30.2491 24.4642C30.2491 20.2536 33.6617 16.8411 37.8722 16.8411C33.6617 16.8411 30.2491 13.4285 30.2491 9.21802Z",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumHydrafacial);
export default __webpack_public_path__ + "static/media/platinum-hydrafacial.58ba9bdce5d79ef5436062663d2d59e0.svg";
export { ForwardRef as ReactComponent };